'use strict';

var _ = require('lodash');
var UserProcessingTransformationService = function UserProcessingTransformationService(ConfigurationService) {
  function getUserDisplayName(userId) {
    var selectedUser = _.find(ConfigurationService.getAllUsers() || [], {
      userId: userId
    });
    if (selectedUser) {
      return selectedUser.getDisplayName();
    }
    return userId;
  }
  return {
    getUserDisplayName: getUserDisplayName
  };
};
UserProcessingTransformationService.$inject = ['ConfigurationService'];
module.exports = UserProcessingTransformationService;